<template>
  <div :class="$style.checkoutLayout">
    <div class="pl-5 pr-5 pt-5 pb-5" :class="$style.container">
      <h2 class="text-center">Checkout</h2>
      <div :class="$style.errorForm" v-if="!empty(errorMessage)">
        <a-tag color="red">{{ errorMessage }}</a-tag>
      </div>
      <a-row :gutter="20" v-else-if="!empty(accountInfo)">
        <a-form :form="form" :layout="'vertical'" id="checkoutInfo">
          <a-col :span="24">
            <h3>Account Information</h3>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Pastor First Name">
              <a-input v-decorator="['pastor_first_name', { rules: [{ required: true, message: 'Please input Pastor First Name!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Pastor Last Name">
              <a-input v-decorator="['pastor_last_name', { rules: [{ required: true, message: 'Please input Pastor Last Name!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Role">
              <a-input v-decorator="['role', { rules: [{ required: true, message: 'Please input role!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Cell phone">
              <a-input v-decorator="['pastor_cell_phone', { rules: [{ required: true, message: 'Please input cell phone!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Church Name">
              <a-input v-decorator="['church_name', { rules: [{ required: true, message: 'Please input church name!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Email">
              <a-input v-decorator="['email', { rules: [{ required: true, message: 'Please input email!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Password">
              <a-input v-decorator="['password', { rules: [{ required: true, message: 'Please input password!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Address">
              <a-input v-decorator="['address', { rules: [{ required: true, message: 'Please input address!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="State">
              <a-input v-decorator="['state', { rules: [{ required: true, message: 'Please input state!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="City">
              <a-input v-decorator="['city', { rules: [{ required: true, message: 'Please input city!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Country">
              <a-input v-decorator="['country', { rules: [{ required: true, message: 'Please input country!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="!empty(planInfo)">
            <h3>Plan Information</h3>
            <b>Plan:</b>
            {{ planInfo.name }}
          </a-col>
        </a-form>
        <a-col :span="24">
          <a-button class="mt-5" type="primary" @click="handleSubmit" :loading="isLoading">Submit</a-button>
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { get, some } from 'lodash';
import UserService from '@/services/UserService';
import CheckoutService from '@/services/CheckoutService';
import initRecurly from '@/services/Recurly';
import { empty } from '@/utils';
export default {
  data() {
    return {
      accountInfo: {},
      planInfo: {},
      isLoading: false,
      errorMessage: '',
      dataRequired: ['recurly_code', 'signature'],
    };
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  async beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'checkout' });
    await initRecurly();
  },
  async mounted() {
    // eslint-disable-next-line camelcase
    const { account_id, plan_code } = this.$route.query;
    console.log(account_id, plan_code, this.$route);
    if (empty(account_id) && empty(plan_code)) {
      this.errorMessage = 'Account and Plan invalid';
    } else {
      try {
        let uInfo;
        if (!empty(account_id)) {
          const resp = await CheckoutService.getAccountInfo(account_id);
          uInfo = resp;
        } else {
          uInfo = await UserService.doGetChurchProfile(false);
        }
        this.doRetrieveAccountInfo(uInfo);
      } catch (error) {
        console.log(error);
        try {
          if (empty(account_id)) {
            const resp = await UserService.doGetChurchProfile(false);
            this.doRetrieveAccountInfo(resp);
          }
        } catch (error2) {
          this.errorMessage = 'Account invalid';
          return;
        }
      }

      // validate plan_code
      if (empty(plan_code)) {
        this.errorMessage = 'Plan invalid';
      } else {
        recurly.plan(plan_code, (err, data) => {
          if (empty(err)) {
            this.planInfo = data;
          } else {
            this.errorMessage = err.message;
          }
        });
      }
    }
  },
  methods: {
    empty,
    doRetrieveAccountInfo(userInfo) {
      if (some(this.dataRequired, item => empty(userInfo[item]))) {
        this.errorMessage = 'Account invalid';
        return;
      }
      this.accountInfo = userInfo;
      // eslint-disable-next-line camelcase
      const { billing_address, billing_city, billing_country, billing_state, billing_firstname, billing_lastname, cell_phone, contact_email, name } = userInfo;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          address: billing_address,
          city: billing_city,
          country: billing_country,
          state: billing_state,
          pastor_first_name: billing_firstname,
          pastor_last_name: billing_lastname,
          pastor_cell_phone: cell_phone,
          email: contact_email,
          church_name: name,
        });
      });
    },
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            const resp = await CheckoutService.doCheckout({
              ...values,
              recurly_code: this.accountInfo.recurly_code,
              signature: this.accountInfo.signature,
              coupon_code: this.accountInfo.coupon_code,
              plan: this.planInfo.code,
            });
            this.$notification['success']({
              message: 'Checkouted successful.',
            });
            console.log(resp);
          } catch (error) {
            console.log({ error });
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
